import styled from 'styled-components';
import { Button, colors, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';

export const TableRowStyled = styled(TableRow)`
  border-bottom: 1px solid ${colors.neutral[300]};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const TableCellStyled = styled(TableCell)`
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: ${colors.neutral[900]};
  letter-spacing: 0.02rem;
  padding: 1.6rem 1rem;

  &:first-child {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  &:last-child {
    padding-right: 2rem;
    text-align: center;
  }
`;

export const InternalNameStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

export const UploadButtonStyled = styled(Button)`
  margin-left: auto;
  padding-left: 0;
`;

export const ButtonsWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;
